(function() {
  function initLuxurySplitScroll() {
    const sectionContainer = document.querySelector('.luxury-split-scroll');
    if (!sectionContainer) return;

    const textItems = sectionContainer.querySelectorAll('.js-lss-text-item');
    const photoWrapper = sectionContainer.querySelector('.js-lss-photo-wrapper');
    const photoItems = sectionContainer.querySelectorAll('.js-lss-photo-item');
    const totalItems = textItems.length;

    if (totalItems === 0) return;

    if (window.innerWidth >= 750) {
      if (!photoWrapper) return;

      // Reset any active mobile tracking attributes safely
      photoItems.forEach(img => img.classList.remove('is-active'));

      function syncSplitScrollMatrix() {
        const rect = sectionContainer.getBoundingClientRect();
        const containerHeight = rect.height;
        const viewportHeight = window.innerHeight;

        // Calculate real-time entry and progress track limits explicitly
        const scrollStartOffset = window.scrollY + rect.top;
        const totalScrollableDistance = containerHeight - viewportHeight;
        const currentScrolledProgress = window.scrollY - scrollStartOffset;

        let ratio = currentScrolledProgress / totalScrollableDistance;
        if (ratio < 0) ratio = 0;
        if (ratio > 1) ratio = 1;

        // Matches 1:1 mouse movement direction perfectly across the window loop
        const maxTranslationShift = (totalItems - 1) * 100;
        const dynamicTranslateY = (1 - ratio) * maxTranslationShift;

        photoWrapper.style.transform = `translate3d(0, -${dynamicTranslateY}vh, 0)`;
      }

      // Safe deployment execution sequence loops
      syncSplitScrollMatrix();
      window.addEventListener('scroll', syncSplitScrollMatrix, { passive: true });
      window.addEventListener('resize', syncSplitScrollMatrix);
      
    } else {
      // Mobile Section Viewport: Ensures first card displays instantly
      if(photoItems[0]) photoItems[0].classList.add('is-active');

      const mobileOptions = {
        root: null,
        rootMargin: '-30% 0px -30% 0px',
        threshold: 0
      };

      const mobileObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = entry.target.getAttribute('data-index');
            photoItems.forEach(img => {
              if (img.getAttribute('data-index') === index) {
                img.classList.add('is-active');
              } else {
                img.classList.remove('is-active');
              }
            });
          }
        });
      }, mobileOptions);

      textItems.forEach(item => mobileObserver.observe(item));
    }
  }

  document.addEventListener('DOMContentLoaded', initLuxurySplitScroll);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initLuxurySplitScroll);
  }
})();